import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  UtilsService, CommunicationService, CompRouterService
} from '../../../../helpers/services/index';
import { NgForm } from '@angular/forms';
import * as moment from 'moment';
import { ImageUpload } from '../../../image-upload.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
  @Input() resource: any;
  @Input() fieldList: any;
  @Input() data: any;
  @Input() disableBtn: any;
  @Input() isAdditionalFieldValid: any;
  @Input() additionalErrorMessage: any;
  @Output() submitForm = new EventEmitter<Object>();
  @Output() selectedRadioValue = new EventEmitter<Object>();
  @Output() selectedDropdownValue = new EventEmitter<Object>(); 
  @Output() delete = new EventEmitter<Object>();
  @Output() addImage = new EventEmitter<Object>();
  @Output() addItem = new EventEmitter<Object>();
  @Output() aiGenerate = new EventEmitter<Object>();
  selectedTagsMap: { [key: string]: string[] } = {};
  tagInputMap: { [key: string]: string } = {};
  constructor(public utils: UtilsService, private imageUpload: ImageUpload) { }

  ngOnInit() {
   this.initializeTagFields();
  }

  ngOnChanges() {
   this.initializeTagFields();
  }

  private initializeTagFields() {
    if (this.fieldList) {
      this.fieldList.forEach(field => {
        if (field.type === 'tag') {
          // Initialize the map if undefined
          if (!this.selectedTagsMap[field.model]) {
            this.selectedTagsMap[field.model] = [];
          }
          
          // Get data from parent component
          const fieldData = this.data && this.data[field.model];
          
          // Update the tags map
          if (Array.isArray(fieldData)) {
            this.selectedTagsMap[field.model] = [...fieldData];
          }
          
          // Initialize input field
          this.tagInputMap[field.model] = '';
        }
      });
    }
  }

  submit(form: NgForm) {
    let obj = { data: this.data, form: form }
    this.submitForm.emit(obj);
    // form.resetForm();
  }

  onAIGenerate(field) {
    this.aiGenerate.emit({ field: field, data: this.data });
  }

  deleteForm() {
    this.delete.emit(this.data);
  }

  clearData(field) {
    this.data[field.model] = "";
    this.data[field.dataObject] = "";
    // this.isAdditionalFieldValid = false;
    // this.additionalErrorMessage = [];
    setTimeout(() => { this.utils.materialInput() }, 200);
  }

  myCallback(field, event) {
    this.selectedDropdownValue.emit({ field: field, value: event });
    if (event[field.model]) {
      this.data[field.model] = event[field.model];
      this.data[field.dataObject] = event[field.dataField]
    } else if (event[field.dataField]) {
      this.data[field.dataObject] = event[field.dataField]
    }
  }

  searchExisting(field) {
    if (field.addNew) {
      let exist = false;
      field.new = false;
      if (this.data[field.model]) {
        if (field.source) {
          field.source.forEach(item => {
            if (item[field.model].toLowerCase().includes(this.data[field.model].toLowerCase())) {
              exist = true;
            }
          });
        }
        if (!exist) {
          field.new = true;
        }
      }
    }
  }

  add(field) {
    let obj = {
      item: field.model,
      data: this.data[field.model]
    }
    // this.isAdditionalFieldValid = false;
    // this.additionalErrorMessage = [];
    this.addItem.emit(obj);
  }

  isItemSelected(item, field) {
    if (item && item[field]) {
      return true;
    }
    return false;
  }

  isFormValid() {
    let valid = true;
    this.fieldList.forEach(field => {
      if (field.required && field.type == 'selection') {
        valid = valid && this.data[field.model] && this.data[field.dataObject]
      }
    });
    return valid;
  }

  selectedRadio(item) {
    this.selectedRadioValue.emit(item);
  }

  dateToChange(field, event) {
    const date1 = moment(event).format('YYYY-MM-DD');
    this.data[field.model] = date1;
  }

  // Image upload
  fileEvent(event: any, field) {
    if (event.target.files && event.target.files[0]) {
      this.imageUpload.readFiles(event.target.files, 0, (fileName, resized_jpeg) => {
        field.imageUrl = resized_jpeg;
        this.addImage.emit(resized_jpeg);
        this.data[field.model] = fileName;
        this.data[field.updated] = true;
      });
    }
  }

  clearImage(field) {
    if (this.data[field.model] === "") {
      this.data[field.updated] = false;
      field.imageUrl = ""
    }
  }

  selectStar(value, field) {
    this.data[field.model] = value;
  }

  addTag(fieldModel: string) {
    const tag = this.tagInputMap[fieldModel] ? this.tagInputMap[fieldModel].trim() : '';
    
    if (tag) {
      if (!this.selectedTagsMap[fieldModel]) {
        this.selectedTagsMap[fieldModel] = [];
      }
      
      if (!this.selectedTagsMap[fieldModel].includes(tag)) {
        this.selectedTagsMap[fieldModel].push(tag);
        this.data[fieldModel] = [...this.selectedTagsMap[fieldModel]];
        this.tagInputMap[fieldModel] = '';
      }
    }
  }

  removeTag(fieldModel: string, tag: string) {
    const index = this.selectedTagsMap[fieldModel].indexOf(tag);
    if (index !== -1) {
      this.selectedTagsMap[fieldModel].splice(index, 1);
      this.updateDataTags(fieldModel);
    }
  }

  removeImage(field) {
    this.data[field.model] = "";
    this.data[field.updated] = false;
    if (this.data['publicImagePath']) {
      this.data['publicImagePath'] = "";
    }
    if (this.data['publicImageId'] !== undefined) {
      this.data['publicImageId'] = "";
    }
    field.imageUrl = "";
    setTimeout(() => { this.utils.materialInput() }, 200);
  }

  private updateDataTags(fieldModel: string) {
    this.data[fieldModel] = [...this.selectedTagsMap[fieldModel]];
  }

}
